module.exports = __webpack_public_path__ + "static/media/icon.2d8c1b00.png";